<template>
  <div class="col-2">
    <slot />
  </div>
</template>
